import { EventListingFragment } from '@/__generated__/graphql';
import { getLanguage } from '@/lib/config';
import { useMobile } from '@/lib/hooks/useMobile';
import { colors, Container, h2, mediaQueries } from '@/theme/lib';
import { ComponentProps } from '@components/ComponentProps';
import styled from 'styled-components';
import EventCard from '../EventCard';
import Mason from '../Mason';
import { isBicentenary } from '@/lib/utils';
import { css } from 'styled-components';

export type EventListingProps = ComponentProps<EventListingFragment>;

const StyledEventListing = styled.div`
  position: relative;
  background: ${(props) => props.theme.colors.eventListing.backgroundColor};
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  overflow: hidden;
  margin-bottom: 3rem;

  h3 {
    ${h2}
    text-transform: ${(props) => props.theme.config.eventListing.textTransform};
    color: ${(props) => props.theme.colors.eventListing.textColor};
    font-family: ${(props) => props.theme.fonts.feature};
  }

  li {
    list-style: none;
  }

  ${mediaQueries.md} {
    margin-bottom: 4rem;

    ul {
      margin-top: 1.25rem;
    }

    li {
      &:nth-child(2n + 1) {
        .event-card-wrapper {
          padding-right: 1rem;
        }
      }

      &:nth-child(2n) {
        .event-card-wrapper {
          padding-left: 1rem;
        }
      }
    }

    .event-card-wrapper {
      padding-top: 2.5rem;
    }
  }
  
  ${props => isBicentenary(props.theme.key) ? css`
    padding-top: 0;
    padding-bottom: 0;
    > div {
      padding-top: 0;
      padding-bottom: 0;
    }
    ${mediaQueries.md} {
      padding-top: 0;
      padding-bottom: 0;
      > div {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  ` : ''};
`;

const StyledList = styled.ul`
  position: relative;
  z-index: 2;
  margin-top: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export default function EventListing(data: EventListingProps) {
  const isMobile = useMobile();
  const language = getLanguage();

  return (
    <StyledEventListing className="EventListingParagraph">
      <Container>
        <h3 lang={language !== 'en' ? language : undefined}>{data.title}</h3>
        {isMobile ? (
          <StyledList>
            {data.cards.map((card) => (
              <li key={card.id}>
                <EventCard {...card} />
              </li>
            ))}
          </StyledList>
        ) : (
          <Mason columns={{ default: { columns: 2 } }}>
            {data.cards.map((card) => (
              <div key={card.id} className="event-card-wrapper">
                <EventCard {...card} />
              </div>
            ))}
          </Mason>
        )}
      </Container>
    </StyledEventListing>
  );
}
